import styled from 'styled-components';

export const ImageListContainer = styled.div<{ $isMobile: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme: { token }, $isMobile }) => ($isMobile ? token.marginXXS : token.margin)}px;
  padding: ${({ theme: { token } }) => token.padding}px;
  ${({ $isMobile }) =>
    $isMobile &&
    `
      padding-top: 0px;
    `};

  .image-list-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .open-image-tags-drawer-btn {
    margin-left: -${({ theme: { token } }) => token.margin}px;
  }

  .mobile-image-select-upload {
    display: block;
    width: 100%;
  }

  .images-available-count {
    margin-top: ${({ theme: { token }, $isMobile }) => ($isMobile ? token.marginXS : token.marginLG)}px;
    font-size: ${({ theme: { token } }) => token.fontSizeLG}px;
  }

  .image-list {
    display: flex;
    flex-wrap: wrap;
    gap: ${({ theme: { token } }) => token.margin}px;
    margin-top: ${({ theme: { token } }) => token.marginLG}px;

    .image-item {
      display: flex;
      flex-direction: column;
      gap: ${({ theme: { token } }) => token.marginXXS}px;
    }

    .download-icon {
      font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;
    }
  }

  .image-upload-buttons-container {
    margin-top: ${({ theme: { token } }) => token.marginSM}px;

    > span > div {
      display: block;
    }
  }
`;

export const ModalContent = styled.div`
  padding: 0;
  padding: ${({ theme: { token } }) => token.marginMD}px ${({ theme: { token } }) => token.marginSM}px
    ${({ theme: { token } }) => token.marginSM}px ${({ theme: { token } }) => token.marginSM}px;
  background-color: ${({ theme: { token } }) => token.colorBgElevated};
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: ${({ theme: { token } }) => token.marginSM}px;

  .image-tags-drawer-title {
    color: ${({ theme: { token } }) => token.colorText};
    font-size: ${({ theme: { token } }) => token.fontSizeHeading3}px;
    font-weight: ${({ theme: { token } }) => token.fontWeightStrong};
    line-height: ${({ theme: { token } }) => token.lineHeightLG};
  }

  .image-tags-list {
    flex-grow: 1;
    overflow-y: auto;
  }

  .image-tags-drawer-close-btn {
    margin: 0 ${({ theme: { token } }) => token.marginXS}px;
  }
`;
